import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { useDispatch } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import useGetMissingScopes from 'routes/Support/components/ClientSupport/components/MappingAndScopes/ScopesProtectionsConfiguration/hooks/useGetMissingScopes';
import CustomizeProtections from './CustomProtections';
import CustomScopes from './CustomScopes';

type ScopesAndProtectionsProps = { selectedBind: string };

const ScopesAndProtections = ({ selectedBind }: ScopesAndProtectionsProps) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // is it normal that all children components fetch for binds ? Why main support component isn't in charge of it ?

    useEffect(() => {
        const bind = selectedBind;
        dispatch.support.fetchDefaultProtections();
        dispatch.support.fetchCustomProtections({ bind });
        dispatch.support.fetchDefaultScopes();
        dispatch.support.fetchCurrentScopes({ bind });
        dispatch.support.fetchCustomScopes({ bind });
    }, [selectedBind]);
    const { missingScopesInProtections, missingProtectionsInScopes } =
        useGetMissingScopes();
    return (
        <Flex direction="column">
            <Typography variant="body1">
                {t('support.scopes.explanationText')}
            </Typography>
            <Flex direction="column">
                <CustomizeProtections
                    selectedBind={selectedBind}
                    missingScopes={missingScopesInProtections}
                />
                <CustomScopes
                    selectedBind={selectedBind}
                    missingScopes={missingProtectionsInScopes}
                />
            </Flex>
        </Flex>
    );
};

export default ScopesAndProtections;
